exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar--2a3xW {\n  display: flex;\n  overflow: hidden;\n  position: relative;\n  width: 125px;\n  height: 125px;\n}\n\n.avatar--2a3xW.circle--1JDQy {\n  border-radius: 50%;\n  border: solid 1px #3b5032;\n}\n\n.avatar--2a3xW.mini--1Idpp {\n  width: 35px;\n  height: 35px;\n}\n\n.avatar--2a3xW.large--2ZHRP {\n  min-width: 200px;\n  width: 200px;\n  height: 200px;\n}\n\n.avatar--2a3xW img {\n  position: absolute;\n  width: 100%;\n  max-width: 100%;\n}\n\n", ""]);

// exports
exports.locals = {
	"avatar": "avatar--2a3xW",
	"circle": "circle--1JDQy",
	"mini": "mini--1Idpp",
	"large": "large--2ZHRP"
};